
<div class="modal-header">
  <h4 class="modal-title ms-3">Add Maintenance Item</h4>
  <button type="button" class="btn-close me-2" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body mx-3">
  
  <div class="alert alert-danger alert-outline-coloured" *ngIf="hasError">
    <div class="alert-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    </div>
    <div class="alert-message">
      <strong>Error occurred.</strong> There was problem adding maintenance on vehicle.
    </div>
  </div>

  <form>
    <div class="row">
      <div class="col-12">
        <hr class="mb-1 mt-3">
        <div class="h4 text-uppercase mb-3">Number of KMs at Scheduled Maintenance</div>
      </div>
      <fieldset class="col-sm-6 mb-3">
        <label class="form-label mb-1">KMs <span class="required">*</span></label>
        <input #scheduledKmsElement="ngModel" name="scheduledKmsElement" [(ngModel)]="scheduledKmsElement.model" [ngClass]="{'is-invalid': scheduledKmsElement.invalid && scheduledKmsElement.touched }" class="form-control" type="number" maxlength="25" required min="0">
        <div class="invalid-feedback lh-sm" *ngIf="scheduledKmsElement.errors?.['required']">Scheduled KMs is a required field.</div>
        <div class="invalid-feedback lh-sm" *ngIf="scheduledKmsElement.errors?.['min']">Scheduled KMs must be a positive value.</div>
      </fieldset>
      <fieldset class="col-sm-6 mb-3">
        <label class="form-label mb-1">Maintenance Period <span class="required">*</span></label>
        <select
          class="form-select"
          #maintenanceTermIdElement="ngModel"
          [(ngModel)]="maintenanceTermIdElement.model"
          name="maintenanceTermIdElement"
          [ngClass]="{'is-invalid': maintenanceTermIdElement.invalid && maintenanceTermIdElement.touched}"
          required
        >
          <option [value]="undefined" selected>[Select...]</option>
          <option *ngFor="let term of terms" [ngValue]="term.termId">{{term.description}}</option>
        </select>
        <div class="invalid-feedback lh-sm" *ngIf="maintenanceTermIdElement.errors?.['required']">Maintenance period is a required field.</div>
      </fieldset>
    </div>
    <div class="row">
      <div class="col-12">
        <hr class="mb-1 mt-3">
        <div class="h4 text-uppercase mb-3">KMs When Maintenance Performed</div>
      </div>
      <fieldset class="col-sm-6 mb-3">
        <label class="form-label mb-1">KMs <span class="required">*</span></label>
        <input required name="performedKmsElement" #performedKmsElement="ngModel" [(ngModel)]="performedKmsElement.model" class="form-control" type="number" min="0" maxlength="25" [ngClass]="{'is-invalid': performedKmsElement.invalid && performedKmsElement.touched}" >
        <div class="invalid-feedback lh-sm" *ngIf="performedKmsElement.errors?.['required']">Performed KMs is a required field.</div>
        <div class="invalid-feedback lh-sm" *ngIf="performedKmsElement.errors?.['min']">Performed Kms must be a positive value.</div>
      </fieldset>
      <fieldset class="col-sm-6 mb-3">
        <label class="form-label mb-1">Date <span class="required">*</span></label>
        <div class="input-group">
          <input 
            class="form-control"
            placeholder="yyyy-mm-dd"
            ngbDatepicker
            #d="ngbDatepicker"
            [maxDate]="maxDate"
            (dateSelect)="formatDate($event)"
            name="performedDateElement"
            #performedDateElement="ngModel"
            [(ngModel)]="performedDateElement.model"
            [ngClass]="{'is-invalid': performedDateElement.invalid && performedDateElement.touched }"
            required
          />
          <button 
            class="btn btn-outline-primary btn-bg-white bi bi-calendar3 rounded-end" 
            [ngClass]="{'is-invalid': performedDateElement.invalid && performedDateElement.touched}" 
            (click)="d.toggle()" 
            type="button"
          >
            Select...
          </button>
          <div class="invalid-feedback lh-sm" *ngIf="performedDateElement.errors?.['required']">Performed date is a required field.</div>
          <div class="invalid-feedback lh-sm" *ngIf="performedDateElement.errors?.['ngbDate']">Performed date must be in the format YYYY-MM-DD.</div>
        </div>
      </fieldset>
    </div>
  </form>
  
</div>

<div class="modal-footer">
  <div class="px-3">
    <button class="btn btn-lg btn-outline-secondary me-3" (click)="closeModal()">Cancel</button>
    <button [disabled]="isSubmitting" class="btn btn-lg btn-success position-relative" (click)="addMaintenanceRecord()">
      <span
        class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
        role="status"
        [ngClass]="{'show': isSubmitting}">
      </span>
      <span class="text fade show">Add Maintenance</span>
    </button>
  </div>
</div>
